// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TextSearchPattern } from "../text-search-pattern";
import { SearchRequestBase } from "./base/search-request-base";

export class ResourceSearchRequest extends SearchRequestBase {
	public override BasicSearchName: string = "";
	public override BasicSearchDescription: string = "";
	public FirstName: TextSearchPattern = new TextSearchPattern();
	public LastName: TextSearchPattern = new TextSearchPattern();
}